import React, { useState } from "react";
import { Menu, MenuItem, Typography, Button } from "@mui/material";
import SortIcon from "@mui/icons-material/Sort";
import { ACQUIRE_CAMPAIGNS, RETAIN_CAMPAIGNS } from "../../RetainDashboard/Utilities/CampaignUtils";

const sortOptions = {
  [RETAIN_CAMPAIGNS]: [
    { value: "date", label: "Date: Newest", order: "desc" },
    { value: "date", label: "Date: Oldest", order: "asc" },
    { value: "orderValue", label: "Order value: High", order: "desc" },
    { value: "orderValue", label: "Order value: Low", order: "asc" },
  ],
  [ACQUIRE_CAMPAIGNS]: [
    { value: "date", label: "Date: Newest", order: "desc" },
    { value: "date", label: "Date: Oldest", order: "asc" },
    { value: "likes", label: "Likes: Highest", order: "desc" },
    { value: "likes", label: "Likes: Lowest", order: "asc" },
  ]
};

export default function SortMenu({ sortBy, orderBy, onSortChange, pageFilter }) {
  const [sortAnchorEl, setSortAnchorEl] = useState(null);

  const handleSortClick = (event) => {
    setSortAnchorEl(event.currentTarget);
  };

  const handleSortClose = () => {
    setSortAnchorEl(null);
  };

  const handleSortSelect = (params) => {
    const {value, order} = params;

    onSortChange({
      sortBy: value,
      orderBy: order,
    });

    handleSortClose();
  };

  return (
    <>
      <Button style={styles.button} onClick={handleSortClick}>
        <SortIcon style={styles.icon} />
        <Typography sx={styles.buttonTitle}>Sort by</Typography>
      </Button>
      <Menu
        anchorEl={sortAnchorEl}
        open={Boolean(sortAnchorEl)}
        onClose={handleSortClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        sx={styles.menu}
      >
        {sortOptions[pageFilter]?.map(({ value, label, order }) => (
          <MenuItem
            key={`${value}-${order}`}
            onClick={() => handleSortSelect({ value, order })}
            sx={styles.menuItem}
            selected={sortBy === value && orderBy === order}
            >
              {label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}

const styles = {
  buttonTitle: {
    fontSize: "14px",
    color: "#302E2A",
    fontFamily: "FustatSemiBold",
    textTransform: "capitalize",
    ml: "6px",
  },
  icon: {
    color: "#302E2A",
  },
  menu: {
    border: "1px solid #D7DBDC",
    borderRadius: "2px",
    mt: 0.5
  },
  menuItem: {
    fontFamily: "FustatMedium",
    fontSize: "13px",
    color: "#302E2A",

    "&.Mui-selected, &.Mui-selected:hover": {
      backgroundColor: "#D7DBDC",
    },
  }
};
